export default __webpack_public_path__ + "static/media/information--flight-port--g1.6ffedaed.png";